import type { ReactElement, ReactNode } from 'react'

import type { TypeAlignmentEntry } from '@contentful-types/alignment'
import type { Background } from '@contentful-types/background'
import type { TypeComponentTitleDescriptionBlockEntry } from '@contentful-types/component-title-description-block'

import type { PageSwoosh } from '@constants/enums/swoosh'

export type TabSectionProps = {
  className?: string
  background?: Background
  heading?: TypeComponentTitleDescriptionBlockEntry
  alignment?: TypeAlignmentEntry
  children: ReactNode
  sectionGroupSwoosh?: PageSwoosh
}

export function GroupTabSection(props: TabSectionProps): ReactElement {
  const { children, ...rest } = props

  console.info('GroupTabSection props:', rest)

  return <div>PLACEHOLDER: group tab section</div>
}
